import { InputGroup } from 'react-bootstrap';
import { Field } from 'formik';
import PropTypes from 'prop-types';

export const BuildingCeilingHeight = ({
  handleChangeCaracObj,
  errors,
  touched,
  values
}) => {
  return (
    <div>
      <label>Altura del techo de la propiedad</label>
      <InputGroup style={{ maxWidth: '150px' }}>
        <InputGroup.Text id="basic-addon1">m</InputGroup.Text>
        <Field
          className="form-control"
          name="characteristics.buildingCeilingHeight"
        />
      </InputGroup>
      {errors?.type && touched?.type && (
        <label className="w-100 text-danger mt-1">{errors.type}</label>
      )}
    </div>
  );
};

BuildingCeilingHeight.propTypes = {
  values: PropTypes.object,
  handleChangeCaracObj: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
